<header id="main-header">
    <div class="master-grid">
        <div class="t-row ai-center">
            <div class="col c--7 mob--9">
                <a class="logo-link" routerLink="/home">
                    <div class="ill-logo">
                        <img src="assets/man-laptop-coffee.png" alt="Man with laptop">
                    </div>
                    <div class="grp-name">
                        <h1 class="base">Housni Issouffa</h1>
                        <p class="t-base">Web developer & Computer graphics specialist</p>
                    </div>
                </a>
            </div>
            <div class="col c--5 mob--3">
                <div class="side-menu">
                    <button (click)="openMenu()" id="tgl-menu" type="button"><span class="b-txt">Menu</span><div class="bt-bars"></div></button>
                </div>
            </div>
        </div>
    </div>
    <nav id="h-nav">
        <div class="menu-box">
            <div (click)="closeMenu()" class="h-nav-items" role="navigation">
                <a routerLink="/home" class="nav-lnk">Accueil</a>
                <a routerLink="/about" class="nav-lnk">À propos</a>
                <a routerLink="/blog"class="nav-lnk">Blog</a>
                <a routerLink="/contact" class="nav-lnk">Contactez-moi</a>
            </div>
        </div>
        <button (click)="closeMenu()" id="s-close" title="Fermer" type="button">&times;</button>
    </nav>
</header>